import type { FilterSection } from "@/types/filter";
import defaultBooleanOptions from "@/utils/constants/defaultBooleanOptions";
import monthsFilterOption from "@/utils/constants/monthsFilterOption";
import yearsFilterOption from "@/utils/constants/yearsFilterOption";

const FILTER_SECTIONS: FilterSection[] = [
  {
    key: 'tenderCategory',
    label: 'Tender Category',
    type: 'select',
    options: [{
      value: "GOODS_AND_SUPPLIES",
      label: "Goods & Supplies"
    },
    {
      value: "CONSULTING_SERVICES",
      label: "Consulting Services"
    },
    {
      value: "PROFESSIONAL_SERVICES",
      label: "Professional Services"
    },
    {
      value: "TECHNICAL_SERVICES",
      label: "Technical Services"
    },
    {
      value: "ICT_AND_SOFTWARE",
      label: "ICT & Software"
    },
    {
      value: "DATA_AND_ANALYTICS",
      label: "Data & Analytics"
    },
    {
      value: "SPACE_TECHNOLOGY_AND_EQUIPMENT",
      label: "Space Technology & Equipment"
    },
    {
      value: "RESEARCH_AND_DEVELOPMENT",
      label: "Research & Development"
    },
    {
      value: "INFRASTRUCTURE_AND_FACILITIES",
      label: "Infrastructure & Facilities"
    },
    {
      value: "CONSTRUCTION_AND_WORKS",
      label: "Construction & Works"
    },
    {
      value: "OPERATIONS_AND_MAINTENANCE",
      label: "Operations & Maintenance"
    },
    {
      value: "TRAINING_AND_CAPACITY_BUILDING",
      label: "Training & Capacity Building"
    },
    {
      value: "EVENTS_AND_LOGISTICS",
      label: "Events & Logistics"
    },
    {
      value: "COMMUNICATIONS_AND_MEDIA",
      label: "Communications & Media"
    },
    {
      value: "LEGAL_AND_COMPLIANCE",
      label: "Legal & Compliance"
    },
    {
      value: "FINANCIAL_AND_AUDIT_SERVICES",
      label: "Financial & Audit Services"
    },
    {
      value: "TRAVEL_AND_ACCOMMODATION",
      label: "Travel & Accommodation"
    },
    {
      value: "OFFICE_ADMINISTRATION",
      label: "Office Administration"
    },
    {
      value: "PARTNERSHIPS_AND_GRANTS",
      label: "Partnerships & Grants"
    },
    {
      value: "OTHER",
      label: "Other"
    }]
  },
    {
    key: 'bidType',
    label: 'Bid Type',
    type: 'select',
    options: [
    {
      value: "REQUEST_FOR_PROPOSAL",
      label: "Request for Proposal"
    },
    {
      value: "REQUEST_FOR_QUOTATION",
      label: "Request for Quotation"
    },
    {
      value: "INVITATION_TO_BID",
      label: "Invitation to Bid"
    },
    {
      value: "EXPRESSION_OF_INTEREST",
      label: "Expression of Interest"
    },
    {
      value: "REQUEST_FOR_INFORMATION",
      label: "Request for Information"
    },
    {
      value: "PREQUALIFICATION",
      label: "Prequalification"
    },
    {
      value: "OPEN_TENDER",
      label: "Open Tender"
    },
    {
      value: "RESTRICTED_TENDER",
      label: "Restricted Tender"
    },
    {
      value: "DIRECT_PROCUREMENT",
      label: "Direct Procurement"
    },
    {
      value: "FRAMEWORK_AGREEMENT",
      label: "Framework Agreement"
    },
    {
      value: "CALL_FOR_CONSULTANTS",
      label: "Call for Consultants"
    },
    {
      value: "GRANT_FUNDING_CALL",
      label: "Grant / Funding Call"
    },
    {
      value: "AUCTION_DISPOSAL",
      label: "Auction / Disposal"
    },
    {
      value: "AWARD_NOTICE",
      label: "Award Notice"
    },
    {
      value: "CANCELLATION_NOTICE",
      label: "Cancellation Notice"
    },
    {
      value: "ADDENDUM_CLARIFICATION",
      label: "Addendum / Clarification"
    }
  ],
  },
  {
    key: 'latest',
    label: 'Is Latest?',
    type: 'boolean',
    options: defaultBooleanOptions,
  },
  {
    key: 'endingSoon',
    label: 'Is Ending Soon?',
    type: 'boolean',
    options: defaultBooleanOptions,
  },
  {
    key: 'year',
    label: 'Year',
    type: 'select',
    options: yearsFilterOption,
  },
  {
    key: 'month',
    label: 'Month',
    type: 'select',
    options: monthsFilterOption,
  },
  //     {
  //   key: 'createdStartDate',
  //   label: "Created At (Start Date)",
  //   type: 'date',
  //   placeholder: 'Select a start date',
  // },
  // {
  //   key: 'createdEndDate',
  //   label: "Created At (End Date)",
  //   type: 'date',
  //   placeholder: 'Select an end date',
  // },
  // {
  //   key: 'publishedStartDate',
  //   label: "Published At (Start Date)",
  //   type: 'date',
  //   placeholder: 'Select a start date',
  // },
  // {
  //   key: 'publishedEndDate',
  //   label: "Published At (End Date)",
  //   type: 'date',
  //   placeholder: 'Select an end date',
  // },
];

export default FILTER_SECTIONS